/** @format */

import React, { useState } from 'react'

import { Button, Modal, Upload, Spin } from 'antd'
import { InboxOutlined, EditOutlined } from '@ant-design/icons'

import Images from '../../../Images'

import serviceUploadFile from './services'

import './style.css'

export default function EditProduct(props) {
	const [modal, setModal] = useState(false)
	const [file, setFile] = useState({
		uploading: false,
		url: '',
	})
	const [updateLoading, setUpdateLoading] = useState(false)

	const handleUploadFile = async (item) => {
		setFile({
			uploading: true,
			url: '',
		})
		let response = await serviceUploadFile({
			file: item.file,
			typeFile: props.type,
		})
		setFile({
			uploading: false,
			url: response?.data[0].url,
		})
	}

	return (
		<>
			<Button type='primary' icon={<EditOutlined />} size='large' onClick={() => setModal(true)}>
				{props.type === 'Recipe' ? 'Editar Recipe' : 'Editar Identificación'}
			</Button>
			<Modal
				title={props.type === 'Recipe' ? 'Editar Recipe' : 'Editar Identificación'}
				visible={modal}
				onCancel={() => setModal(false)}
				footer={[
					<Button key='back' onClick={() => setModal(false)}>
						Cerrar
					</Button>,
					<Button
						key='submit'
						type='primary'
						loading={updateLoading}
						disabled={file.url ? false : true}
						onClick={async () => {
							setUpdateLoading(true)
							let response = await props.handleEditRutOrRecipe({
								url: file.url,
								product: props.product,
								typeFile: props.type,
							})
							setUpdateLoading(false)
							if (response === 200) setModal(false)
						}}>
						Actualizar
					</Button>,
				]}>
				<Upload.Dragger
					listType='picture-card'
					fileList={[]}
					beforeUpload={() => false}
					onChange={handleUploadFile}
					onPreview={true}>
					<p className='ant-upload-drag-icon'>
						<InboxOutlined />
					</p>
					<p className='ant-upload-text'>Haz click o arrastre el {props.type.toLowerCase()} a subir</p>
					<p className='ant-upload-hint'>
						<li>Formatos Soportados: JPG,JPEG,PDF,PNG</li>
						<li>Tamaño máximo de archivo: 20MB</li>
						<li>Suba una imagen visible y de fácil lectura</li>
					</p>
				</Upload.Dragger>

				{file.uploading ? (
					<Spin size='large' />
				) : (
					<Images
						classContent={''}
						classImage={'ph-recipe-upload-component-image'}
						default={file.url}
						alt={''}
						title={''}
					/>
				)}
			</Modal>
		</>
	)
}
